module.exports = __webpack_public_path__ + "img/markerClusterIcon.cf62260f.svg";